export default function setErrors(dispatch, action) {
  return (errors) => dispatch({
    type: action,
    payload: errors,
  });
}
